<template>
  <div>
    <div>
    <!-- ドメインによってバナーを切り替え -->
    <ul class="banner" v-if="isDomain(0)">
        <!-- JMEC -->
        <li v-if="showOrderFunction(clinicInfo)" class="banner-item"><a tabindex="-1" target="_blank" class="bt" v-on:click="startOrder()"><img src="../../static/img/domain1/各種ご注文.png"></a></li>         
        <li class="banner-item"><a href="" target="_blank" class="bt"><router-link to="/practiceSupport"><img src="../../static/img/domain1/使い方・臨床等のお問い合わせ.png"></router-link></a></li>
        <li class="banner-item"><a href="" target="_blank" class="bt"><router-link to="/inspection"><img src="../../static/img/domain1/点検依頼.png"></router-link></a></li>                
      </ul>
      <ul class="banner" v-if="isDomain(0)">
        <li class="banner-item"><a href="" target="_blank" class="bt"><router-link to="/servicereportlist"><img src="../../static/img/domain1/サービスレポート一覧.png"></router-link></a></li>
          <li class="banner-item"><a href="" target="_blank" class="bt"><router-link to="/jlearninglist"><img src="../../static/img/domain1/J-learning一覧.png"></router-link></a></li> 
        <li class="banner-item"><a href="https://rbserissa.eco-serv.jp/jmec-invoice/" target="_blank" class="bt"><img src="../../static/img/domain1/WEB請求書.png"></a></li>        
      </ul>      
      <ul class="banner" v-if="isDomain(0)">        
        <li class="banner-item"><a href="https://docs.google.com/forms/d/e/1FAIpQLSebhwOZ91XlZzqZ5hFyIPeRxLo96V0abOtH37-j_BCqQa_14Q/viewform" target="_blank" class="bt"><img src="../../static/img/domain1/施設掲載はこちら.png"></a></li>
        <li class="banner-item"><a href="https://jmec-seminar.com/" target="_blank" class="bt"><img src="../../static/img/domain1/bnr_seminar_concierge.png" alt="セミナーコンシェルジュ"></a></li>
      </ul>      
      
      <ul class="banner" v-if="isDomain(1)">
        <!-- C-edge -->
        <li class="banner-item"><a href="https://cedge-inc.com/" target="_blank" class="bt"><img src="../../static/img/domain2/bnr_C-edgec_official.png" alt="C-edge公式サイト"></a></li>
        <li class="banner-item"><a href="https://cedge-inc.com/seminar/" target="_blank" class="bt"><img src="../../static/img/domain2/bnr_MSA.png" alt="美容医療のセミナー情報サイト"></a></li>
      </ul>
      <ul class="banner" v-if="isDomain(2)">
        <!-- Contact YM -->
        <li class="banner-item"><a href="https://contactym-inc.com/" target="_blank" class="bt"><img src="../../static/img/domain3/bnr_C-YM_official.png" alt="Contact YM公式サイト"></a></li>
        <li class="banner-item"><a href="https://cedge-inc.com/seminar/" target="_blank" class="bt"><img src="../../static/img/domain3/bnr_MSA.png" alt="美容医療のセミナー情報サイト"></a></li>
      </ul>
    </div>

    <OrderFormModal 
    :propsName="orderFormModalName"
    :propsDisplayItems="displayItems"  
    @selectOrderItem="selectedItem"  
    ref="order_form_modal" />

    <SelectBillingUserModal 
    :propsName="selectBillingUserModalName" 
    :propsBillings="billingInfoList"
    :propsSelectedBilling="selectBullingInfo"
    @selectedBilling="selectedBilling"
    @callGoOrderForm="goOrderFormPage"  
    ref="select_billing_modal" />
    
    <!-- インジケーター -->
    <Indicator ref="indicator" />

  </div>
</template>

<script>
import OrderFormModal from '../components/OrderFormModal.vue'
import SelectBillingUserModal from './SelectBillingUserModal.vue';
import Indicator from './Indicator.vue'
import authMixins from '../mixins/AuthUtil';
import apiMixins from '../mixins/ApiUtil';
import cookieUtil from '../mixins/CookieUtil';
export default {
    name: 'Banner',
    mixins: [apiMixins, cookieUtil, authMixins],
    components: {
      OrderFormModal,     
      SelectBillingUserModal, 
      Indicator
    },
    data () {
        return {
          orderFormModalName: "banner_order_form_modal",   
          selectBillingUserModalName: "banner_select_billing_user_modal",                      
          accountInfo: null,   // アカウント情報          
          billingInfoList: null,
          selectBullingInfo: null,
          displayItems: [],
          clinicCode: "",
          clinicInfo: null,
          selectedItemType: null
        }
    },
    methods: {
      //#region API周り
      /**-------------------------------------------------- API ------------------------------------------ */     
      /**
       * 請求先情報の取得を行う
       */
      requestBillings: async function () {    
        const userId = await this.getUserId();              
        var queryStringParameters = {
            user_id: userId,
            clinic_code: this.clinicCode
        }      
        const result = await this.requestGetBillingList(queryStringParameters);        
                    
        const detail = this.getResultOfGetBillingUser(result);

        if (detail.isSuccess) {
            this.billingInfoList = result.data.data.billings;
        }            
      },
      /**
       * 特定クリニック情報の取得を行う
       */
      requestSpecificClinicInfo: async function () {
        const result = await this.requestGetClinic(this.clinicCode);

        if (result === null || result.data.data.length <= 0) {
            return;
        }

        this.clinicInfo = result.data.data;            
      },   
      /**------------------------------------------------------------------------------------------------- */        
      //#endregion

      //#region 請求先選択・商品種別選択モーダルの各種処理
      /**-----------------------------請求先選択・商品種別選択モーダルの各種処理------------------------------ */                
      /**
       * 注文開始 商品種別選択       
       */
      startOrder: async function() {
        this.clear();

        // 請求先情報・出庫先情報の取得
        this.$refs.indicator.doAjax();                                
        await this.requestBillings();
        await this.requestSpecificClinicInfo();
        this.$refs.indicator.onCancel();

        this.setOrderItem();
        this.showOrderFormModal();                
      },
      /**
       * 商品種別選択モーダルで選択された際に呼ばれる
       * @param selectedItemType 選択した商品の種別
       */
      selectedItem: async function (selectedItemType) { 
        this.hideOrderFormModal();           
        // 選択した商品種別を一時保管
        this.selectedItemType = selectedItemType;        

        if (this.billingInfoList && this.billingInfoList.length == 1) {
            // 請求先をCookieに保存して、注文フォームへ遷移する
            this.saveBillingOfCookie(this.billingInfoList[0]);
            this.goOrderFormPage();
        } else {
            // 請求先選択
            this.showSelectBillingModal();
        }                
      },
      /**
       * 表示する商品の設定を行う
      */
      setOrderItem () {                        
        var displayItems = [];
        // 一覧に変換
        displayItems = this.convertDisplayItemsToStringArray(this.clinicInfo.display_items);
        // 表示対象広告の設定
        this.displayItems = displayItems;            
      }, 
      /**
       * 請求先が選択された際に呼ばれる
       * 請求先の保存を行う
       * @param billing 選択された請求先
       */
      selectedBilling: async function(billing) {                        
        this.saveBillingOfCookie(billing);            
      }, 
      /**         
       * 選択中の請求ユーザーコードをCookieに保存する
       */
      saveBillingOfCookie (billingInfo) {            
        this.setBillingUserCodeToCookie(billingInfo.code);            
      }, 
      /**------------------------------------------------------------------------------------------------- */                
      //#endregion

      //#region 画面遷移周り
      /**---------------------------------------------- 画面遷移 ------------------------------------------ */       
      /**
       * 注文フォームへ遷移
       */
        goOrderFormPage () {
          this.$router.push({
              name: 'OrderForm',
              query: { type: this.selectedItemType }
          });
      }, 
      /**------------------------------------------------------------------------------------------------- */                
      //#endregion
      
      //#region モーダル表示周り
      /**---------------------------------------------- モーダル表示 ------------------------------------------ */       
      showOrderFormModal () {                
        this.$refs.order_form_modal.show();
      }, 
      /**
       * 注文メニューのダイアログを閉じる
       */
        hideOrderFormModal() {
          this.$refs.order_form_modal.hide();
      },           
      /**
       * 注文メニューのダイアログを表示
      */
      showOrderFormModal() {            
          this.$refs.order_form_modal.show();
      },              
      /**
       * 請求先選択のダイアログを表示
      */
      showSelectBillingModal () {
        this.selectBullingInfo = null;
          this.$refs.select_billing_modal.show();
      },
      /**
       * 請求先選択ダイアログを閉じる
      */
      hideSelectBillingModal () {
          this.$refs.select_billing_modal.hide();            
      }, 
      /**----------------------------------------------------------------------------------------------------- */       
      //#endregion         
      
      clear() {                    
        this.accountInfo = null;        
        this.billingInfoList = null;
      },      
    },
    mounted: async function () {      
      this.$refs.indicator.doAjax();                                        
      this.clinicCode = await this.getClinicCodeForCognito();
      await this.requestSpecificClinicInfo();
      this.$refs.indicator.onCancel();   
    }   
}
</script>


// WEBPACK FOOTER //
// src/components/Banner.vue